import { ReactNode, createContext } from 'react';

import { ListSize } from '../ListBoxBase/types';
import { TextPresetWithSkin } from '../TextGeneric/types';

interface ListContextType {
    size: ListSize;
    onItemClick?: () => void;
}

export const ListContext = createContext<ListContextType>({ size: 'm' });

export function getTextPresetWithSkin(option?: { caption?: ReactNode }): TextPresetWithSkin {
    return option?.caption ? 'current-main + current-caption' : 'current-main';
}
